<!--
select-on-tab
(forge-autocomplete-change)="valueChange($event)"
-->
<!-- TODO: Update to forge-autocomplete when upgraded to Angular 8+ -->
<!-- <form [formGroup]="typeAheadFormGroup">
<forge-autocomplete #autocomplete [formControlName]="searchTextControlName" [filter]="filterListener"
  [highlightFirst]="autoActiveFirstOption">
  <forge-text-field [invalid]="isInvalid" [required]="isRequired">
    <input type="text" #typeahead>
    <label *ngIf="!hideLabel">{{label}}</label>
    <span slot="helper-text" *ngIf="hasError('required')">{{label}} is required</span>

    <span slot="helper-text">{{getDisplayValue(formControl.value)}}</span>

    <span *ngIf="hasCustomValidators">
      <span slot="helper-text" *ngFor="let customError of customErrors">
        <span *ngIf="showErrorMessage(customError.errorKey)">
          {{customError.message}}
        </span>
      </span>
    </span>
  </forge-text-field>
</forge-autocomplete>
</form> -->

<forge-text-field [invalid]="isInvalid" [required]="isRequired" density="small">
  <input #typeahead type="text" [formControl]="searchTextControl" [matAutocomplete]="dropdown"
    [attr.telemetry]="label">

    @if (hasIcon) {
      <forge-icon-button slot="end" dense (click)="iconActionClick()">
        <forge-tooltip>{{iconTooltip}}</forge-tooltip>
        <forge-icon [name]="iconName"></forge-icon>
      </forge-icon-button>
    }

    @if (!hideLabel) {
      <label slot="label">{{label}}</label>
    }

    <mat-autocomplete #dropdown="matAutocomplete" [displayWith]="getDisplayValueFn()"
      [autoActiveFirstOption]="autoActiveFirstOption" panelWidth="auto">
      @for (option of options; track option) {
        <mat-option [value]="getValue(option)">
          <span [innerHTML]="getDisplayValue(option) | highlight: searchInputText">
          </span>
        </mat-option>
      }
    </mat-autocomplete>

    @if (hasError('required')) {
      <span slot="support-text">
        {{label}} is required
      </span>
    }

    @if (helperTextSpacer) {
      <span slot="support-text"></span>
    }

    @if (hasCustomValidators) {
      <span>
        @for (customError of customErrors; track customError) {
          <span slot="support-text">
            @if (hasError(customError.errorKey)) {
              <span>
                {{customError.message}}
              </span>
            }
          </span>
        }
      </span>
    }
  </forge-text-field>